module.exports = __webpack_public_path__ + "static/ef67e12db9b8dca79bf7d6a6e327fa52b5121a07fc93071d3539f19671ea107e-541520fa9d5ee83505562ef42c5aef5b.jpeg";